//Development
//exports.ip = "http://localhost:4000"

//Production
 exports.ip = "http://aspirantes.itmexicali.edu.mx:4000"

//Docker
// exports.ip = "http://192.168.99.100:4000"
//exports.ip = "http://201.143.23.157:4000"
